module.exports = __webpack_public_path__ + "static/img/ud-wifi-1.57204c67.png";